// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//Page Component

import ContactComponent from './PageComponent/ContactComponent';

function Contact() {

  useMeta({
    title: 'Connect to our consultant now for your Blinds requirements',
    description: 'Create customized blinds as per your desire & Interior Design demands. Contact now for wide range of design, texture, visibility and openness',
    canonical: 'https://callistusblinds.com/contact/',
    og: {
      locale: 'en_US',
      type: 'article',
      title: 'Connect to our consultant now for your Blinds requirements',
      description:
        'Create customized blinds as per your desire & Interior Design demands. Contact now for wide range of design, texture, visibility and openness',
      url: 'https://callistusblinds.com/contact/',
      site_name: 'Callistus Blinds',
    },
  });

  return (
    <div>
      <Navbar />
      <NotificationBar />
      <ContactComponent />
      <Footer />
    </div>
  );
}

export default Contact;
